import React from 'react';
import dynamic from 'next/dynamic';

const UnitedStates = dynamic(() => import('./united-states'));
const HongKong = dynamic(() => import('./hong-kong'));
const Singapore = dynamic(() => import('./singapore'));
const Malaysia = dynamic(() => import('./malaysia'));

type Props = {
  flagName: string;
  className?: string;
};

const Icon: React.FC<Props> = ({ className, flagName }: Props) => {
  const iconClassNames = `h-14 w-21 ${className}`;
  const flags = {
    US: <UnitedStates className={iconClassNames} />,
    HK: <HongKong className={iconClassNames} />,
    SG: <Singapore className={iconClassNames} />,
    MY: <Malaysia className={iconClassNames} />,
  };
  return <>{flags[flagName as keyof typeof flags]}</>;
};

export default Icon;
